import React from 'react';
import { SoundBar } from '@components/SoundBar';
import { RefetchOnComplete } from '@graphql/helpers/effects';
import {
  ArtistLatestReleaseDocument,
  gql,
  SetArtistPickedReleaseDocument,
  useQuery,
} from '@graphql/reactQuery';
import { formatDateFromTime } from '@utils/helpers';
import { ProfileTopSectionSkeleton } from './ProfileTopSectionSkeleton';

/*#__PURE__*/ gql(/* GraphQL */ `
  query ArtistLatestRelease($artistId: UUID!, $filter: ArtistReleasesFilter) {
    artist(id: $artistId) {
      id
      pickedRelease {
        id
        mintStartTime
        ...SoundBarRelease
      }
      releases(pagination: { first: 1, sort: DESC }, filter: $filter) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        edges {
          cursor
          node {
            id
            mintStartTime
            ...SoundBarRelease
          }
        }
      }
    }
  }
`);

RefetchOnComplete({
  trigger: [SetArtistPickedReleaseDocument],
  refetch: [ArtistLatestReleaseDocument],
});

export const ArtistPick = ({ artistId }: { artistId: string }) => {
  const { data: artistReleasesData, isLoading: isLatestReleaseLoading } = useQuery(
    ArtistLatestReleaseDocument,
    {
      variables: { artistId },
      staleTime: 0,
      cacheTime: 0,
    },
  );

  const artistReleases = artistReleasesData?.data?.artist?.releases;
  const featuredRelease = artistReleasesData?.data?.artist?.pickedRelease;

  const artistPickRelease = featuredRelease ?? artistReleases?.edges?.[0]?.node;

  return (
    <div className="mt-6 flex flex-col gap-2 bg-white px-5 md:mt-12 lt:px-0">
      <div className="font-title text-title-m font-medium md:text-title-l">Artist Pick</div>

      {isLatestReleaseLoading ? (
        <ProfileTopSectionSkeleton />
      ) : (
        artistPickRelease && (
          <SoundBar
            releaseFrag={artistPickRelease}
            collectButtonSource="Featured Sound Sound Bar"
            mintReferral={null}
            source="Artist Pick"
            customSubTitle={
              <p className="font-base text-base-s text-white opacity-60">
                Release Date {formatDateFromTime({ time: artistPickRelease.mintStartTime })}
              </p>
            }
          />
        )
      )}
    </div>
  );
};
